import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
    selector: 'nx-edit-text-input',
    template: `
    <div>
      <label for="text">{{label}}<ng-container *ngIf=isRequired()>*</ng-container></label>
      <input
        [type]="maskContent ? 'password' : 'text'" 
        [value]="text"
        (input)="onInputChange($event)"
        (blur)="onBlur()"
        [placeholder]=placeholder
        id="text"
        pInputText
        [disabled]="isDisabled"
        [ngClass]="{'invalid': ngControl?.invalid && ngControl?.touched}"
      />
      <small *ngIf="helpText">{{helpText}}</small>
      <small class="error" *ngIf="ngControl?.errors?.emailExists">E-Mail existiert bereits.</small>
    </div>
  `,
    styles: [`

  `],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditTextInputComponent),
            multi: true
        }
    ]
})
export class EditTextInputComponent implements ControlValueAccessor, OnInit {

    ngControl: NgControl;
    isDisabled: boolean;
    @Input() label: string;
    @Input() placeholder: string = '';
    @Input() helpText: string;
    @Input() maskContent: boolean = false;

    text: string;

    private onChange: (value: string) => void;
    private onTouched: () => void;

    constructor(private _injector: Injector) {
    }

    ngOnInit() {
        this.ngControl = this._injector.get(NgControl);
        this.ngControl.valueAccessor = this;
    }

    writeValue(text: string): void {
        this.text = text;
    }

    registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        // Optional: Implementieren Sie die Logik zum Deaktivieren des Steuerelements
        this.isDisabled = isDisabled;
    }

    onInputChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.text = input.value;
        if (this.onChange) {
            this.onChange(this.text);
        }
    }

    onBlur(): void {
        if (this.onTouched) {
            this.onTouched();
        }
    }

    isRequired(): boolean {
        return this.ngControl?.control?.hasValidator(Validators.required);
    }

}